(() => {
  const storageKey = 'hm-coll-view';

  function normalizeView(view) {
    return view === 'list' ? 'list' : 'grid';
  }

  function getSavedView() {
    try {
      return normalizeView(window.localStorage.getItem(storageKey));
    } catch (error) {
      return 'grid';
    }
  }

  function saveView(view) {
    try {
      window.localStorage.setItem(storageKey, normalizeView(view));
    } catch (error) {
      // localStorage can be unavailable in private or restricted browsing.
    }
  }

  function applyView(view) {
    const nextView = normalizeView(view);
    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    grid.classList.toggle('product-grid--list', nextView === 'list');

    document.querySelectorAll('[data-hm-view]').forEach((button) => {
      const isActive = button.dataset.hmView === nextView;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function startGridObserver() {
    const container = document.querySelector('#ProductGridContainer');
    if (!container) return;

    const observer = new MutationObserver(() => {
      applyView(getSavedView());
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest('[data-hm-view]');
    if (!button) return;

    const view = normalizeView(button.dataset.hmView);
    saveView(view);
    applyView(view);
  });

  document.addEventListener('DOMContentLoaded', () => {
    applyView(getSavedView());
    startGridObserver();
  });
})();
